export default __webpack_public_path__ + "5129fbe03355cc3f14e991157ad86c8b.svg";